
import React, { useState } from "react";
import { useAuthState } from "@/hooks/useAuthState";
import { Button } from "@/components/ui/button";
import TemplateDrawer from "@/components/templates/TemplateDrawer";
import TemplatesList from "@/components/templates/TemplatesList";

export default function TemplatesPage() {
  const { user } = useAuthState();
  const [addDrawerOpen, setAddDrawerOpen] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  
  // Extract tenantId safely from user metadata
  const tenantId = user?.app_metadata?.tenant_id || "";
  
  const handleOpenAddDrawer = () => {
    setAddDrawerOpen(true);
  };
  
  const handleTemplateCreated = () => {
    // Increment to trigger refresh
    setRefreshTrigger(prev => prev + 1);
  };
  
  return (
    <>
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold tracking-tight mb-2">Templates</h1>
          <p className="text-muted-foreground">
            Create and manage reusable email templates
          </p>
        </div>
        
        <Button onClick={handleOpenAddDrawer}>
          Add Template
        </Button>
        
        <TemplateDrawer
          tenantId={tenantId} 
          mode="create"
          onSuccess={handleTemplateCreated} 
          open={addDrawerOpen}
          onOpenChange={setAddDrawerOpen}
          triggerButton={false}
        />
      </div>
      
      <TemplatesList 
        tenantId={tenantId} 
        onCreateTemplate={handleOpenAddDrawer}
        refreshTrigger={refreshTrigger} 
      />
    </>
  );
}
